<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="90%"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main ref="main" @radio-change="onRadioChange" />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="confirm()"
        :disabled="notCheck"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  data() {
    return { checkedRow: null }
  },
  computed: {
    notCheck() {
      return !this.checkedRow || this.checkedRow === {}
    },
  },
  methods: {
    onRadioChange({ newValue }) {
      this.checkedRow = newValue
    },
    confirm() {
      if (!this.checkedRow) return
      this.$emit('confirm', this.checkedRow)
      this.close()
    },
    close() {
      this.checkedRow = null
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
